import { ComponentPropsWithoutRef } from 'react';

export const FireflyAnimated = (props: ComponentPropsWithoutRef<'svg'>) => (
  <svg
    width="61"
    height="83"
    viewBox="0 0 61 83"
    fill="none"
    {...props}
  >
    <path
      filter="url(#fillPartial)"
      d="M44.1876 54.325C44.773 50.3111 44.7245 46.2292 44.0388 42.2315C43.3466 38.3502 42.0528 34.6015 40.2028 31.1213C37.7996 26.5155 34.397 22.5081 30.2408 19.3869C29.9723 20.3604 29.7459 21.3437 29.5583 22.3366C28.9114 25.7522 28.7756 29.2421 29.154 32.6965C29.5454 36.2705 30.4381 39.7669 31.803 43.0919C33.1485 46.3715 37.0427 51.7407 41.2248 55.8419L39.4265 57.6758C35.8622 54.7681 31.6639 52.4361 29.0764 51.6695C26.8511 50.9773 24.5514 50.5536 22.2227 50.4049C21.0842 50.3499 19.9424 50.366 18.8039 50.4566C17.6816 50.5569 16.5657 50.7283 15.4628 50.9644C14.8967 51.0841 14.3372 51.2329 13.7873 51.3946C14.3695 52.1288 14.9905 52.8274 15.6504 53.4905C17.5101 55.3535 19.6416 56.9222 21.9801 58.1351C24.3897 59.3803 26.9708 60.2601 29.6392 60.7485C32.3625 61.2369 35.1441 61.2983 37.8869 60.9329L39.9472 61.9452C39.0351 65.0503 38.0357 67.958 37.3112 70.9789C36.9425 72.4377 36.6611 73.919 36.4702 75.4133C36.4379 75.6882 36.4153 75.9567 36.3991 76.2187C36.5964 76.0408 36.8034 75.8435 36.9942 75.643C38.0325 74.5627 39.006 73.4242 39.9084 72.2274C41.8006 69.7822 43.5601 67.1526 45.4069 64.5166L48.0397 65.8071C47.0047 69.0092 45.5816 72.0722 43.7994 74.9249C42.8841 76.416 41.8361 77.8197 40.6717 79.12C40.0184 79.8542 39.2907 80.514 38.4982 81.0962C37.984 81.4681 37.4212 81.7722 36.826 81.9954C36.3959 82.1506 35.9463 82.2412 35.487 82.2638H35.0827C34.9565 82.2638 34.7689 82.2282 34.6105 82.2023C33.9474 82.0859 33.3361 81.7819 32.8412 81.3291C32.728 81.2256 32.6148 81.1124 32.5113 80.9959C32.4208 80.8924 32.3399 80.7824 32.2623 80.6692C32.0035 80.2908 31.7998 79.8768 31.6671 79.4402C31.4828 78.8353 31.3858 78.2078 31.3728 77.5739C31.3599 76.5971 31.4504 75.6203 31.638 74.6597C31.9809 72.9487 32.4725 71.2733 33.1129 69.6528C33.8342 67.8092 34.7043 66.0271 35.7102 64.3225C33.5852 64.7268 31.4213 64.8982 29.2607 64.8336C26.0813 64.7301 22.9375 64.1576 19.9295 63.129C16.8503 62.0746 13.949 60.5512 11.3356 58.6138C8.70284 56.6376 6.36112 54.3023 4.37843 51.6727L0.97583 47.2093L6.29967 45.715C7.66136 45.3171 9.04245 44.9905 10.4397 44.7349C14.6153 43.9716 18.8977 44.0557 23.041 44.9807C24.7423 45.3753 26.4145 45.8993 28.0349 46.5494C27.7923 46.2098 27.5594 45.8637 27.333 45.5177C25.0528 42.0213 23.2771 38.2208 22.0512 34.2296C20.7931 30.1316 20.1462 25.8719 20.13 21.583C20.1268 17.2327 20.7025 12.9019 21.8475 8.7036L23.9563 0.753418L30.4542 5.74411C34.3032 8.58393 37.7187 11.9704 40.5844 15.8031C43.3984 19.5906 45.5783 23.8115 47.0338 28.3009C48.4731 32.6576 49.2235 37.2117 49.2559 41.8013C49.2559 43.3183 49.1491 44.8352 48.9421 46.336C49.2526 45.9317 49.5761 45.5306 49.906 45.1586C51.0542 43.797 52.2833 42.5097 53.59 41.2968C53.9296 40.9895 54.2595 40.6854 54.6315 40.3911C55.0034 40.0968 55.3463 39.7928 55.7506 39.5081L56.3425 39.0779L57.012 38.6736C57.5101 38.3728 58.0308 38.1076 58.5677 37.8877L60.4987 43.7775C55.1134 45.3915 50.4203 49.3925 46.8527 55.1983L44.1973 54.325H44.1876Z"
      fill="currentColor"
    />
    <defs>
      <filter
        id="fillPartial"
        primitiveUnits="objectBoundingBox"
        x="0%"
        y="0%"
        width="100%"
        height="100%"
      >
        <feFlood
          x="0%"
          y="0%"
          width="100%"
          height="100%"
          floodColor={props.floodColor}
        />
        <feOffset dy="0">
          <animate
            attributeName="dy"
            values="1; 0.7; 0.4; 0"
            dur="4s"
            keySplines="0 0.54 1 0.52; 0 0.54 1 0.52; 0 0.54 1 0.52; 0 0.54 1 0.52;"
            keyTimes="0; 0.3; 0.9; 1"
          />
        </feOffset>
        <feComposite
          operator="in"
          in2="SourceGraphic"
        />
        <feComposite
          operator="over"
          in2="SourceGraphic"
        />
      </filter>
    </defs>
  </svg>
);
